<template>
  <el-dialog :visible.sync="visible"
             :title="!dataForm.id ? $t('add') : $t('update')"
             :close-on-click-modal="false"
             :close-on-press-escape="false"
             width="40%">
    <el-form :model="dataForm"
             :rules="dataRule"
             ref="dataForm"
             label-position="top"
             class="dict-add-form">
      <el-row class="row-mar-l">
        <el-col>
          <el-form-item prop="name"
                        :label="$t('model.name')">
            <el-input v-model="dataForm.name"
                      :placeholder="$t('model.name')"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row class="row-mar-l inputValue">
        <el-col>
          <el-form-item prop="key"
                        :label="$t('model.key')">
            <el-input v-model="dataForm.key"
                      :placeholder="$t('model.key')"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row class="row-mar-l inputValue">
        <el-col>
          <el-form-item prop="description"
                        :label="$t('model.description')">
            <el-input v-model="dataForm.description"
                      :placeholder="$t('model.description')"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <template slot="footer">
      <el-button type="button" class="buttonqx" @click="visible = false">{{ $t('user.back') }}</el-button>
      <el-button type="button" class="buttomqr el-button--primary"
                 @click="dataFormSubmitHandle()">{{ $t('user.save') }}</el-button>
    </template>
  </el-dialog>
</template>

<script>
import debounce from 'lodash/debounce'
export default {
  data () {
    return {
      visible: false,
      dataForm: {
        id: '',
        name: '',
        key: '',
        description: ''
      }
    }
  },
  computed: {
    dataRule () {
      return {
        name: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        key: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    init () {
      this.visible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].resetFields()
      })
    },
    // 表单提交
    dataFormSubmitHandle: debounce(function () {
      this.$refs['dataForm'].validate((valid) => {
        if (!valid) {
          return false
        }
        this.$request.postAct('/act/model', this.dataForm).then((res, total, code, data) => {
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              this.visible = false
              this.$emit('refreshDataList')
            }
          })
        }).catch((err) => {
          console.log(err)
        })
      })
    }, 1000, { 'leading': true, 'trailing': false })
  }
}
</script>
<style lang="scss" scope>
.el-input-number {
  width: 100% !important;
}
.el-input__inner {
  text-align: left !important;
}
.buttonqx{
    margin: 0px !important;
    width: 50%;
    background-color: #434343;
    color: #fff;
    border: 0px;
    line-height: 25px;
}
.buttonqx:hover {
  background: #535151 !important;
}
.buttomqr{
    margin-left: 0px !important;
    float: left !important;
    width: 50% !important;
    line-height: 23px;
}
.dict-add-form{
  margin-left: 105px;
  .row-mar-l {
    margin-bottom: 0px;
  }
}
.inputValue{
  margin-top: 8px;
}
</style>
